import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";

// dinamically create pages routes
import routes from "routes.js";

class Pages extends Component {
  componentWillMount() {
    if (document.documentElement.className.indexOf("nav-open") !== -1) {
      document.documentElement.classList.toggle("nav-open");
    }
  }
  getPageClass() {
    var pageClass = "";
    switch (this.props.location.pathname) {
      case "/auth/login-page":
        pageClass = " login-page";
        break;
      case "/auth/register-page":
        pageClass = " register-page";
        break;
      case "/auth/lock-screen-page":
        pageClass = " lock-page";
        break;
      case "/auth/recuperar-senha":
        pageClass = " recuperar-senha";
        break;
      default:
        pageClass = "";
        break;
    }
    return pageClass;
  }
  getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return;
      }
    });
  };
  render() {
    return (
      <div>
        <title>Painel | Grupo Locutores Comerciais</title>
        <div className="wrapper wrapper-full-page">
          <div className={"full-page" + this.getPageClass()} data-color="black">
            <div className="content" style={{ paddingTop: "0", background: '#fff' }}>
              <Switch>{this.getRoutes(routes)}</Switch>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Pages;
